import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Crown, Users } from "lucide-react";
import { GameRoom } from "@/providers/play-provider";

export const RoomPlayers = ({ room }: { room: GameRoom }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="w-5 h-5" />
          플레이어 ({room.players.length}/{room.maxPlayers})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {room.players.map((player: { id: string; name: string }) => (
            <div
              key={player.id}
              className="flex items-center justify-between p-2 bg-muted rounded"
            >
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="font-medium">{player.name}</span>
                {player.id === room.hostId && (
                  <Crown className="w-4 h-4 text-yellow-500" />
                )}
              </div>
              <div className="flex-1">
                <span className="text-sm text-muted-foreground">
                  {room.status === "waiting" ? "준비완료" : "플레이 중"}
                </span>
              </div>
            </div>
          ))}

          {Array.from({
            length: room.maxPlayers - room.players.length,
          }).map((_, index) => (
            <div
              key={`empty-${index}`}
              className="flex items-center justify-between p-2 bg-muted/50 rounded border-dashed border"
            >
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
                <span className="text-muted-foreground">빈 자리</span>
              </div>
              <div className="flex-1">
                <span className="text-sm text-muted-foreground">대기중...</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
